<template>
  <div id="yhubDetail" class="">
    <el-row>
      <div class="headTitle">
        <!-- <span v-if="basicinfo.deviceName" style="font-size: 18px;margin-right: 20px;"> {{ basicinfo.deviceName }}</span>
        <span v-if="basicinfo.deviceName" class="fontStyle2" /> -->
        <span style="font-size: 18px;">
          <!-- {{ $t('AllDevices.BatteryMonitor') }} -->
          {{ $t('BondOrUpdateDevice.SN') }}:{{ basicinfo.yhubSn }}</span>
        <!-- <span class="fontStyle2" /> -->
        <!-- <span class="fontStyle1">{{ $t('adminView.YhubFirmVersion') }}:{{ basicinfo.fwVersion }}</span> -->
        <!-- <span class="fontStyle2" /> -->
        <!-- <span class="fontStyle1">{{ basicinfo.mechBrand }}/{{ basicinfo.mechModel }} {{ basicinfo.batteryVoltage }} V</span>
        <span class="fontStyle2" /> -->
        <!-- <span class="fontStyle1">{{ $t('BondOrUpdateDevice.OwnedCompany') }}：{{ basicinfo.companyName }}</span> -->

      </div>
    </el-row>
    <el-row class="tableWarp">
      <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
        <!-- <p class="blockTitleP" style="display:inline-block;padding: 10px 0 0px 20px;">{{ $t('adminView.Alldevices') }}
        </p> -->
        <div style="position: relative;padding:10px 20px 20px;width:100%;">
          <el-table :data="allDeviceTableData" style="width: 100%" border>
            <el-table-column prop="deviceId" :label="$t('adminView.DeviceID')" align="center" />
            <el-table-column prop="deviceTypeZh" :label="$t('sim.Types')" align="center" />
            <el-table-column prop="hardwareVersion" :label="$t('adminView.hardwareVersion')" align="center">
              <!-- 如果为锂电池，则第一个为主板，第二个为副板 -->
              <template slot-scope="scope">
                <div style="text-align: center;">
                  <p>{{ scope.row.hardwareVersion }}</p>
                  <!-- <p v-if="scope.row.deviceType!='e'">{{ scope.row.hardwareVersion }}</p> -->
                  <!-- <p v-else-if="scope.row.deviceType=='e'">{{ scope.row.bms }}{{ scope.row.hardwareVersion }}</p> -->
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="fwVersion" :label="$t('adminView.CurrentFirmVer')" align="center" />
            <el-table-column prop="wlstatus" :label="$t('AllDevices.Status')" align="center">
              <!-- 0:发送更新指令；1：开始更新；2：更新成功；3：更新失败 -->
              <template slot-scope="scope">
                <div style="text-align: center;">
                  <p v-if="scope.row.status==0">{{ $t('adminView.WaitConfirm') }}</p>
                  <p v-else-if="scope.row.status==1">
                    <!-- 更新中{{ scope.row.updatedPercentage }} -->
                    <el-progress :percentage="scope.row.updatedPercentage" />
                  </p>
                  <p v-else-if="scope.row.status==2">{{ $t('adminView.Updated') }}</p>
                  <p v-else-if="scope.row.status==3">{{ $t('adminView.FailUpdate') }}</p>
                  <p v-else-if="scope.row.status==4">{{ $t('adminView.Transferring') }}...</p>
                  <p v-else>--</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('yhubReport.Operating')" align="center">
              <template slot-scope="scope">
                <div style="text-align: center;">
                  <!-- <el-button type="primary" :disabled="updating" size="mini" @click="updateFw(scope.row,scope.$index)">更新</el-button> -->
                  <el-button type="primary" size="mini" @click="updateFw(scope.row,scope.$index)">
                    {{ $t('adminView.select_fv') }}</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <!-- 列表模块————分页 -->
          <!-- <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
            <div class="pagination-container">
              <el-pagination
                v-if="pageshow1"
                background
                current-page.sync="listQuery.pageInfo.page"
                :page-sizes="listQuery1.pageInfo.pageList"
                :page-size="listQuery1.pageInfo.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="listQuery1.pageInfo.total"
                @size-change="handleSizeChange1"
                @current-change="handleCurrentChange1"
              />
            </div>
          </div> -->
        </div>
      </el-col>
    </el-row>
    <!-- 版本更新历史 -->
    <el-row class="tableWarp">
      <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
        <p class="blockTitleP" style="display:inline-block;padding: 10px 0 0px 20px;">
          {{ $t('adminView.UpdateHistory') }}</p>
        <div style="position: relative;padding:10px 20px 20px;width:100%;">
          <el-table :data="fwHistoryTableData" style="width: 100%" border>
            <el-table-column prop="deviceId" :label="$t('adminView.DeviceID')" align="center" />
            <el-table-column prop="deviceModel" :label="$t('adminView.hardwareVersion')" align="center" />
            <el-table-column prop="oldVersion" :label="$t('adminView.FWBeforeUpdate')" align="center" />
            <el-table-column prop="newVersion" :label="$t('adminView.FWVersionUpdate')" align="center" />
            <el-table-column prop="updateTime" :label="$t('adminView.UpdateAt')" align="center" />
            <el-table-column prop="createName" :label="$t('adminView.UpdateBy')" align="center" />
            <!-- 0:发送更新指令；1：开始更新；2：更新成功；3：更新失败 -->
            <el-table-column prop="status" :label="$t('AllDevices.Status')" align="center">
              <template slot-scope="scope">
                <div style="text-align: center;">
                  <p v-if="scope.row.status==0">{{ $t('adminView.WaitConfirm') }}</p>
                  <p v-else-if="scope.row.status==1">
                    <el-progress :percentage="scope.row.updatedPercentage" />
                  </p>
                  <p v-else-if="scope.row.status==2">{{ $t('adminView.Updated') }}</p>
                  <p v-else-if="scope.row.status==3">{{ $t('adminView.FailUpdate') }}</p>
                  <p v-else-if="scope.row.status==4">{{ $t('adminView.Transferring') }}...</p>
                  <p v-else>--</p>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <!-- 列表模块————分页 -->
          <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
            <div class="pagination-container">
              <el-pagination v-if="pageshow2" background current-page.sync="listQuery.pageInfo.page" :page-sizes="listQuery2.pageInfo.pageList" :page-size="listQuery2.pageInfo.limit" layout="total, sizes, prev, pager, next, jumper" :total="listQuery2.pageInfo.total" @size-change="handleSizeChange2" @current-change="handleCurrentChange2" />
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 配置更新历史 -->
    <!-- <el-row class="tableWarp">
      <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
        <p class="blockTitleP" style="display:inline-block;padding: 10px 0 0px 20px;">
          {{ $t('adminView.config_record') }}</p>
        <div style="position: relative;padding:10px 20px 20px;width:100%;">
          <el-table :data="setHistoryTableData" style="width: 100%" border>
            <el-table-column type="expand">
              <template slot-scope="scope">
                <el-form label-position="left" class="demo-table-expand" inline style="padding: 0 20px;">
                  <el-col :xs="12" :sm="12" :lg="8">

                    <el-form-item :label="$t('AllDevices.HardwareV')" style="margin-right: 40px;">
                      <span v-if="scope.row.voltClass==1">{{ $t('AllDevices.HighVVersion') }}</span>
                      <span v-else>{{ $t('AllDevices.NonHighVVersion') }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="$t('AllDevices.SampAlgorithm')" style="margin-right: 40px;">
                      <span v-if="scope.row.samplingMode==1">{{ $t('AllDevices.DynamicSamp') }}</span>
                      <span v-if="scope.row.samplingMode==1"> [ {{ scope.row.voltChangeRate }} mV ]</span>
                      <span v-if="scope.row.samplingMode==2">{{ $t('AllDevices.StaticSampling') }}</span>
                      <span v-if="scope.row.samplingMode==2"> [ {{ scope.row.samplingRate }}
                        {{ $t('dataAndTime.Second') }} ]</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="$t('AllDevices.GPSFunction')" style="margin-right: 40px;">
                      <span v-if="scope.row.gpsFunction==1">{{ $t('AllDevices.FullyTurnOnGPS') }}</span>
                      <span v-if="scope.row.gpsFunction==2">{{ $t('AllDevices.TurnOffGPS') }}</span>
                      <span v-if="scope.row.gpsFunction==3">{{ $t('AllDevices.StartGPS2h') }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="$t('AllDevices.NetFeatures')" style="margin-right: 40px;">
                      <span v-if="scope.row.netFunction==1">{{ $t('AllDevices.FullyOpenNet') }}</span>
                      <span v-if="scope.row.netFunction==2">{{ $t('AllDevices.StartNetOnce') }}</span>
                      <span v-if="scope.row.netFunction==3">{{ $t('AllDevices.StartNet2h') }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="$t('BondOrUpdateDevice.SensorType')" style="margin-right: 40px;">
                      <span>{{ scope.row.sensorTypeTd }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="12" :sm="12" :lg="8">
                    <el-form-item label="APN" style="margin-right: 40px;">
                      <span>{{ scope.row.apn }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="12" :sm="12" :lg="8">
                    <el-form-item label="CAN" style="margin-right: 40px;">
                      <span>{{ scope.row.can }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="$t('BondOrUpdateDevice.AuxVolAcquisition')" style="margin-right: 40px;">
                      <span>{{ handleExtral(scope.row.extrals, 5) }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="$t('BondOrUpdateDevice.currentCollection')" style="margin-right: 40px;">
                      <span>{{ handleExtral(scope.row.extrals, 4) }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="$t('BondOrUpdateDevice.canopenBaudrate')" style="margin-right: 40px;">
                      <span v-if="scope.row.canopenBaudrate==1">125K</span>
                      <span v-else-if="scope.row.canopenBaudrate==2||!scope.row.canopenBaudrate">250K</span>
                      <span v-else-if="scope.row.canopenBaudrate==3">500K</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="$t('BondOrUpdateDevice.NodeID')" style="margin-right: 40px;">
                      <span>{{ scope.row.nodeID }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="$t('BondOrUpdateDevice.communication')" style="margin-right: 40px;">
                      <span>{{ scope.row.communication485Zh }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="scope.row.configFrom==204" :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="$t('AllDevices.cellNumber')" style="margin-right: 40px;">
                      <span>{{ scope.row.cell }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="scope.row.configFrom==204" :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="$t('adminView.showPosition')" style="margin-right: 40px;">
                      <span v-if="scope.row.locationStatus">{{ $t('BondOrUpdateDevice.On') }}</span>
                      <span v-else>{{ $t('BondOrUpdateDevice.Off') }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="scope.row.configFrom==204" :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="$t('allDeviceDetail.RemainingTime')" style="margin-right: 40px;">
                      <span v-if="scope.row.showAvailableTime">{{ $t('BondOrUpdateDevice.Yes') }}</span>
                      <span v-else>{{ $t('BondOrUpdateDevice.No') }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="scope.row.configFrom==204" :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="$t('AllDevices.IgnitionReport')" style="margin-right: 40px;">
                      <span v-if="scope.row.hourMeterStatus">{{ $t('BondOrUpdateDevice.Yes') }}</span>
                      <span v-else>{{ $t('BondOrUpdateDevice.No') }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="scope.row.configFrom==204" :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="$t('AllDevices.IgnitionVoltage')" style="margin-right: 40px;">
                      <span>{{ scope.row.openIgnitionVol }} V</span>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="scope.row.configFrom==204" :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="$t('AllDevices.UseVoltageTh')" style="margin-right: 40px;">
                      <span>{{ scope.row.workHourmeterVol }} V</span>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="scope.row.configFrom==204" :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="$t('adminView.showHalfV')" style="margin-right: 40px;">
                      <span v-if="scope.row.halfV">{{ $t('BondOrUpdateDevice.Yes') }}</span>
                      <span v-else>{{ $t('BondOrUpdateDevice.No') }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="scope.row.configFrom==204" :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="$t('BondOrUpdateDevice.fullChargeTime')" style="margin-right: 40px;">
                      <span>{{ scope.row.fullChargeTime }} {{ $t('dataAndTime.Min') }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="scope.row.configFrom==204" :xs="12" :sm="12" :lg="8">
                    <el-form-item :label="$t('dashboard.SiteName')" style="margin-right: 40px;">
                      <span>{{ scope.row.site ||'--' }}</span>
                    </el-form-item>
                  </el-col>
                  
                </el-form>
              </template>
            </el-table-column>
            <el-table-column prop="batteryModel" :label="$t('adminView.battery')" align="center" width="150px">
              <template slot-scope="scope">
                {{ scope.row.batteryBrand }} / {{ scope.row.batteryModel }}
              </template>
            </el-table-column>
            <el-table-column prop="batteryTotalah" :label="$t('BondOrUpdateDevice.Capacity')" align="center" />
            <el-table-column prop="batterySystemVolt" :label="$t('basicinfo.SystemVoltage')" align="center" />
            <el-table-column prop="supportWaterlevelTd" :label="$t('BondOrUpdateDevice.LevelSensor')" align="center" />
            <el-table-column prop="supportRelaycontrolTd" :label="$t('BondOrUpdateDevice.RemoteControl')" align="center" />
            <el-table-column prop="ledSettingTd" :label="$t('BondOrUpdateDevice.LEDIndicator')" align="center" />
            <el-table-column prop="extralFuntionTd" :label="$t('BondOrUpdateDevice.Track')" align="center" />
            
            <el-table-column prop="sourceTd" :label="$t('adminView.OperationSource')" align="center" />
            <el-table-column prop="updateTime" :label="$t('adminView.UpdateAt')" align="center" />
            <el-table-column prop="updateBy" :label="$t('adminView.UpdateBy')" align="center" />
            <el-table-column prop="status" :label="$t('AllDevices.Status')" align="center">
              <template slot-scope="scope">
                <div style="text-align: center;">
                  <p v-if="scope.row.status==1">{{ $t('adminView.beSent') }}</p>
                  <p v-else-if="scope.row.status==2">{{ $t('adminView.SentSuccess') }}</p>
                  <p v-else-if="scope.row.status==3">{{ $t('adminView.Expired') }}</p>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
            <div class="pagination-container">
              <el-pagination
                v-if="pageshow4"
                background
                current-page.sync="listQuery.pageInfo.page"
                :page-sizes="listQuery4.pageInfo.pageList"
                :page-size="listQuery4.pageInfo.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="listQuery4.pageInfo.total"
                @size-change="handleSizeChange4"
                @current-change="handleCurrentChange4"
              />
            </div>
          </div>
        </div>
      </el-col>
    </el-row> -->
    <!-- 远程校准历史 -->
    <!-- <el-row class="tableWarp">
      <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
        <p class="blockTitleP" style="display:inline-block;padding: 10px 0 0px 20px;">
          {{ $t('adminView.CalibrationHistory') }}</p>
        <div style="position: relative;padding:10px 20px 20px;width:100%;">
          <el-table :data="calibrationHistoryTableData" style="width: 100%" border>
            <el-table-column prop="updateTime" :label="$t('adminView.CalibrationTime')" align="center" />
            <el-table-column prop="cmd" :label="$t('adminView.CalibrationOperation')" align="center">
              <template slot-scope="scope">
                <div style="text-align: center;">
                  <p>{{ $t('adminView.CalOp' + scope.row.cmd) }}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="param" :label="$t('adminView.CalibrationValue')" align="center">
              <template slot-scope="scope">
                <div style="text-align: center;">
                  <p>{{ scope.row.value }}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="resultCode" :label="$t('adminView.CalibrationStatus')" align="center">
              <template slot-scope="scope">
                <div style="text-align: center;">
                  <p v-if="scope.row.resultCode==200">{{ $t('adminView.Updated') }}</p>
                  <p v-else>{{ $t('adminView.FailUpdate') }}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="userName" :label="$t('adminView.CalibrationUser')" align="center" />
          </el-table>
          <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
            <div class="pagination-container">
              <el-pagination
                v-if="pageshow5"
                background
                current-page.sync="listQuery5.pageInfo.page"
                :page-sizes="listQuery5.pageInfo.pageList"
                :page-size="listQuery5.pageInfo.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="listQuery5.pageInfo.total"
                @size-change="handleSizeChange5"
                @current-change="handleCurrentChange5"
              />
            </div>
          </div>
        </div>
      </el-col>
    </el-row> -->
    <!-- 物联网卡信息
    <el-row class="tableWarp">
      <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
        <p class="blockTitleP" style="display:inline-block;padding: 10px 0 0px 20px;">{{ simType }}
          {{ $t('sim.IoTCardInfo') }}</p>
        <div style="position: relative;padding:10px 20px 20px;width:100%;">
          <el-table :data="simData" style="width: 100%" border class="simTable">
            <el-table-column prop="name1" :label="$t('allDeviceDetail.Attributes')" align="center" class="simLabel" />
            <el-table-column prop="value1" :label="$t('allDeviceDetail.Value')" align="center" />
            <el-table-column prop="name2" :label="$t('allDeviceDetail.Attributes')" align="center" class="simLabel" />
            <el-table-column prop="value2" :label="$t('allDeviceDetail.Value')" align="center" />
          </el-table>
        </div>
      </el-col>
    </el-row> -->
    <!-- 计算SOH
    <el-row :gutter="40" style="margin: 20px 0 0 0;">
      <el-col :xs="24" :sm="24" :lg="24" style="padding:0 20px 20px;background:white;position:relative;">
        <p class="blockTitleP" style="display:inline-block;padding-left:0;">{{ $t('warningPage.SOH') }}</p>
        <div style="display: flex;justify-content: space-between;">
          <el-date-picker v-model="sohSearchObj.sohStartAndEndtime" type="daterange" :range-separator="$t('AllDevices.to')" :start-placeholder="$t('AllDevices.startDate')" :end-placeholder="$t('AllDevices.endDate')" @change="changeSOhTime" />
          <div style="max-width: calc(100% - 360px);display: flex;justify-content: flex-end;align-items: center;">
            <span style="margin-left:10px;">{{ $t('allDeviceDetail.ignoreCharg') }}:</span>
            <el-select v-model="sohSearchObj.ignoreCharge" :placeholder="$t('allDeviceDetail.ignoreCharg')" class="filter-item" filterable style="width: 15%; padding-left: 10px;padding-right: 10px" @change="sohChangeSearch">
              <el-option v-for="(item,index) in ignoreChargeOptions" :key="index" :label="item.label" :value="item.value" />
            </el-select>
            <span style="margin-left:10px;">{{ $t('allDeviceDetail.saveDatabase') }}:</span>
            <el-select v-model="sohSearchObj.updateData" :placeholder="$t('allDeviceDetail.saveDatabase')" class="filter-item" filterable style="width: 15%; padding-left: 10px;padding-right: 10px" @change="sohChangeSearch">
              <el-option v-for="(item,index) in updateDataOptions" :key="index" :label="item.label" :value="item.value" />
            </el-select>
            <el-button align="right" :disabled="!sohSearchObj.sohStartAndEndtime||sohSearchObj.sohStartAndEndtime.length==0" style="text-align: center;float:right;" class="filter-item" type="primary" @click="computedSoh()">
              {{ $t('allDeviceDetail.CalculateSOH') }}</el-button>
          </div>
        </div>
        <el-table v-loading="loadingSoh" :data="sohData" borderstyle="width: auto;margin-top:10px;" fit class="myTable">
          <el-table-column :label="$t('yhubReport.StartingTime')" prop="start_timeZh" align="center" />
          <el-table-column :label="$t('yhubReport.EndTime')" prop="end_timeZh" align="center" />
          <el-table-column :label="$t('allDeviceDetail.dischargeA')" prop="currentUsing" align="center" />
          <el-table-column :label="$t('allDeviceDetail.highCurrent')" prop="current_capacity" align="center" />
          <el-table-column :label="$t('allDeviceDetail.SocVolt')" prop="socVolt" align="center" />
          <el-table-column :label="$t('allDeviceDetail.TheorySoc')" prop="soc_ll" align="center" />
          <el-table-column :label="$t('allDeviceDetail.Smoothsoc')" prop="soc_ph" align="center" />
          <el-table-column :label="$t('allDeviceDetail.SocNotSmooth')" prop="soc_wph" align="center" />
          <el-table-column :label="$t('allDeviceDetail.SocMidway')" prop="soc_zt" align="center" />
          <el-table-column :label="$t('allDeviceDetail.SOHaverage')" prop="soh_avg" align="center" />
          <el-table-column :label="$t('allDeviceDetail.FinallyAH')" prop="theoretical_capacity" align="center" />
        </el-table>
      </el-col>
    </el-row> -->
    <!-- 选择版本弹窗 -->
    <el-dialog :close-on-click-modal="false" :title="$t('adminView.FirmwareVersion')" :visible.sync="isShowPop" width="80%">
      <el-table :data="fwList" border fit highlight-current-row>
        <!-- <el-table-column label="硬件型号" prop="deviceModel" align="center" /> -->
        <!-- <el-table-column label="Updated" prop="updateTime" align="center" /> -->
        <el-table-column :label="$t('adminView.FileName')" prop="deviceName" align="center" />
        <el-table-column :label="$t('adminView.FirmwareVersion')" prop="deviceModel" align="center" />
        <el-table-column :label="$t('adminView.Version')" prop="deviceVersion" align="center" />
        <!-- <el-table-column label="Size" prop="fileSize" align="center" /> -->
        <el-table-column :label="$t('warningPage.Remark')" prop="remark" align="center" />
        <el-table-column :label="$t('yhubReport.Operating')" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="selectFW(scope.row)">{{ $t('adminView.select') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 列表模块————分页 -->
      <!-- <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
        <div class="pagination-container">
          <el-pagination
            v-if="pageshow3"
            background
            current-page.sync="listQuery.pageInfo.page"
            :page-sizes="listQuery3.pageInfo.pageList"
            :page-size="listQuery3.pageInfo.limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="listQuery3.pageInfo.total"
            @size-change="handleSizeChange3"
            @current-change="handleCurrentChange3"
          />
        </div>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
import { decimalToBinary, binaryToDecimal } from '@/utils/index'
import { listSohRecord, countSoh } from '@/api/yhub'
import { getUpdateDeviceDetail, findDeviceInfo, getMhxqByMcuId, getLastBMSRecor2, getLastBMSRecor, pageYhubConfigLog, sysDictInfo, getUpdateVersionLog, pageDeviceSystemVersionList, PushUpdateIndex, updateLogStatus, deviceUpdateVersion, pageRemoteControlRecord } from '@/api/firmwareUpdate'
import { canFunctionList } from '@/api/allDevice'
import { pagination } from '@/utils/init_table' // 分页
import i18n from '@/i18n'
import { getDateAndHour, howLongAgo } from '@/utils/updateTime.js'

export default {
  name: 'DashboardAdmin',
  components: {},
  data() {
    return {
      listQuery1: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow1: true,
      listQuery2: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow2: true,
      pageshow3: true,
      // 分页----end
      // 分页----start
      listQuery4: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow4: true,
      listQuery5: {
        pageInfo: pagination()
      },
      pageshow5: true,
      // 分页----end
      basicinfo: {},
      allDeviceTableData: [],
      fwHistoryTableData: [],
      calibrationHistoryTableData: [],
      // 弹窗
      isShowPop: false,
      fwList: [],
      selectDeviceObj: {},
      yhubmqtt: {},
      updating: false,
      deviceTypeOptions: [],
      setHistoryTableData: [],
      simData: [],
      sohData: [],
      sohSearchObj: {
        sohStartAndEndtime: [],
        ignoreCharge: false,
        updateData: false
      },
      ignoreChargeOptions: [
        { label: i18n.t('allDeviceDetail.Yes'), value: true },
        { label: i18n.t('allDeviceDetail.no'), value: false }
      ],
      updateDataOptions: [
        { label: i18n.t('allDeviceDetail.Yes'), value: true },
        { label: i18n.t('allDeviceDetail.no'), value: false }
      ],
      simType: '', // 网卡类型
      loadingSoh: false,
      sensorRangeOptions: [
        { key: 1, label: '300A', disabled: false },
        { key: 3, label: '750A', disabled: false },
        { key: 2, label: '800A', disabled: true }
      ],
      canOptions: []
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    },
    storeYhubmqtt() {
      return this.$store.state.yhubmqtt// 需要监听的数据
    }
  },
  watch: {
    storeYhubmqtt: {
      handler(newValue, oldValue) {
        this.yhubmqtt = newValue // 把新值赋值给我们的属性数据
        this.MQTT()
      },
      deep: true
    },
    language(newValue, oldValue) {
      //this.queryMhxqByMcuId()
      this.queryListSetHistory()
      this.queryListCalibrationHistory()
      this.ignoreChargeOptions[0].label = this.updateDataOptions[0].label = i18n.t('allDeviceDetail.Yes')
      this.ignoreChargeOptions[1].label = this.updateDataOptions[1].label = i18n.t('allDeviceDetail.no')
    }
  },
  beforeRouteLeave(to, from, next) {
    to.meta.keepAlive = true
    next()
  },
  mounted() {
    setTimeout(() => {
      this.queryListAllDevice()
    })
    this.queryListFwHistory()
    // setTimeout(() => {
    //   this.queryListSetHistory()
    // })
    this.queryList()
    //this.queryMhxqByMcuId()
    // this.queryListCalibrationHistory()
  },
  created() {
    this.init()
    this._canFunctionList()
  },
  methods: {
    handleExtral(arr, index) { // 处理extral
      // let arr = decimalToBinary(val)
      // console.log(arr)
      return arr[index] ? this.$t('BondOrUpdateDevice.Yes') : this.$t('BondOrUpdateDevice.No')
    },
    _canFunctionList() {
      canFunctionList().then((res) => {
        this.canOptions = res.resultModel
      })
    },
    queryListAllDevice() {
      getUpdateDeviceDetail({ mcuId: this.$route.query.mcuId }).then(res => {
        console.log('设备类型列表：', res)
        if (res.resultCode == 1001) {
          console.log('deviceTypeOptions:', this.deviceTypeOptions)
          // res.resultModel.deviceList.push(res.resultModel.deviceList[1])
          this.basicinfo.yhubSn = res.resultModel.yhubSn
          this.basicinfo.fwVersion = res.resultModel.fwVersion
          this.allDeviceTableData = res.resultModel.deviceList
          // var num = 0
          this.allDeviceTableData.forEach((v, i) => {
            if (v.status === 0 || v.status === 1) {
              this.selectDeviceObj.index = i
              this.selectDeviceObj.deviceId = v.deviceId
              this.selectDeviceObj.fileCount = v.fileCount
              this.selectDeviceObj.fwVersion = v.fwVersion
              this.allDeviceTableData[this.selectDeviceObj.index].statusS = 1
            }
            // if (v.deviceType == 'e' && num == 0) { // 如果是锂电池，要分主版和副版，所以添加一巷
            //   var vs = JSON.parse(JSON.stringify(v))
            //   this.allDeviceTableData.push(vs)
            //   num++
            // }
          })
          this.allDeviceTableData.forEach((v, i) => {
            this.deviceTypeOptions.forEach(m => {
              if (m.value == v.deviceType) v.deviceTypeZh = m.label
            })
            // if (v.deviceType == 'e') {
            //   switch (i % 2) {
            //     case 0:this.allDeviceTableData[i].bms = '(BMS1)'; console.log(' this.allDeviceTableData', this.allDeviceTableData); break
            //     case 1:this.allDeviceTableData[i].bms = '(BMS2)'; console.log(' this.allDeviceTableData', this.allDeviceTableData); break
            //   }
            // }
          })
          console.log(' this.allDeviceTableData', this.allDeviceTableData)
          this.updating = this.allDeviceTableData.some((v) => {
            return v.status === 0 || v.status === 1
          })
        }
      })
    },
    queryListFwHistory() {
      var param = {
        'mcuId': this.$route.query.mcuId,
        'pageNum': this.listQuery2.pageInfo.pageNum,
        'pageSize': this.listQuery2.pageInfo.pageSize
      }
      getUpdateVersionLog(param).then(res => {
        if (res.resultCode == 1001) {
          this.fwHistoryTableData = res.resultModel.list
          this.listQuery2.pageInfo.total = res.resultModel.total // 分页
          this.fwHistoryTableData.forEach(v => {
            v.updateTime = getDateAndHour(new Date(v.startUpdateTime).getTime())
          })
        }
      })
    },
    queryListCalibrationHistory() {
      var param = {
        'mcuId': this.$route.query.mcuId,
        'pageNum': this.listQuery5.pageInfo.pageNum,
        'pageSize': this.listQuery5.pageInfo.pageSize,
        'startTime': 0,
        'endTime': 2524579200000
      }
      pageRemoteControlRecord(param).then(res => {
        if (res.resultCode == 1001) {
          this.calibrationHistoryTableData = res.resultModel.list
          this.listQuery5.pageInfo.total = res.resultModel.total // 分页
          this.calibrationHistoryTableData.forEach(v => {
            v.updateTime = getDateAndHour(new Date(v.insertTime).getTime())
            const cmd = v.cmd; const param = v.param
            if (cmd == 3 || cmd == 4) {
              v.value = param + '%'
            } else if (cmd == 6) { // 6：闭合/断开。 true 闭合，false 断开。如果是断开，只需要传false；如果是闭合，需要传闭合开始时间和结束时间（精确到秒的时间戳）。
              const arr = param.split(',')
              if (arr[0] == 'false') {
                v.value = i18n.t('adminView.RelayOff')
              } else {
                const startTime = getDateAndHour(new Date(arr[1] * 1000).getTime())
                const endTime = getDateAndHour(new Date(arr[2] * 1000).getTime())
                v.value = i18n.t('adminView.RelayOn') + '[' + startTime + ' -' + endTime + ']'
              }
            } else if (cmd == 8 || cmd == 12) {
              v.value = param + 'V'
            } else if (cmd == 10) {
              const arr = param.split(',')
              const chaAh = arr[0]; const disAh = arr[1]; const chaWh = arr[2]; const disWh = arr[3]
              const chaAhTxt = i18n.t('adminView.ChaAh'); const disAhTxt = i18n.t('adminView.DisAh')
              const chaWhTxt = i18n.t('adminView.ChaWh'); const disWhTxt = i18n.t('adminView.DisWh')
              v.value = chaAhTxt + ':' + chaAh + 'Ah, ' + disAhTxt + ':' + disAh + 'Ah, '
              v.value += chaWhTxt + ':' + chaWh + 'Wh, ' + disWhTxt + ':' + disWh + 'Wh'
            } else if (!param) {
              v.value = '--'
            } else {
              v.value = param
            }
          })
        }
      })
    },
    queryListSetHistory() {
      var param = {
        mcuId: this.$route.query.mcuId,
        pageNum: this.listQuery4.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery4.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      pageYhubConfigLog(param).then(res => {
        console.log('配置记录：', res)
        this.setHistoryTableData = []
        if (res.resultCode == 1001) {
          if (!res.resultModel) return
          this.listQuery4.pageInfo.total = res.resultModel.total // 分页
          res.resultModel.list.forEach(v => {
            if (v.sensorType == 1) {
              v.hallDirectionTd = v.hallDirection == 2 ? i18n.t('BondOrUpdateDevice.Reverse') : i18n.t('BondOrUpdateDevice.Forward')
            } else {
              v.hallDirectionTd = ''
            }
            /* switch (v.canFuntion) {
              case 0: v.can = '0 YHUB'; break
              case 1: v.can = '1 doogle'; break
              case 2: v.can = '2 pgt'; break
              case 3: v.can = '3 hsm'; break
              case 4: v.can = '4 Kisae'; break
              case 5: v.can = '5 BMS'; break
              case 6: v.can = '6 GPD'; break
              case 7: v.can = '7 hoppecke'; break
              case 8: v.can = '8 EVE_BMS'; break
              case 9: v.can = '9 SinoboomCAN'; break
              case 10: v.can = '10 EVE_F477'; break
              case 11: v.can = '11 Yhub_info'; break
              case 12: v.can = '12 CANopen'; break
            }*/
            if (typeof (this.canOptions[v.canFuntion]) !== 'undefined') {
              v.can = (this.canOptions[v.canFuntion].code + ' ' + this.canOptions[v.canFuntion].des)
            }
            // 101:Android、102:IOS、103:Uni-APP（安卓）、104:Xtools、201:VUE前端、105:Uni-APP（IOS）、106:Uni-APP（安卓微信小程序）、
            // 107：蓝牙（安卓App）、108：蓝牙（IOSAPP）、109:Uni-APP（IOS微信小程序）、202:安卓微信小程序-蓝牙、203:IOS微信小程序-蓝牙
            switch (v.configFrom) {
              case 101: v.configFromZh = 'Android'; break
              case 102: v.configFromZh = 'IOS'; break
              case 103: v.configFromZh = 'Uni-APP(Android)'; break
              case 104: v.configFromZh = 'Xtools'; break
              case 105: v.configFromZh = 'Uni-APP(IOS)'; break
              case 106: v.configFromZh = i18n.t('adminView.UniAnWeChat'); break
              case 107: v.configFromZh = i18n.t('adminView.BleAnApp'); break
              case 108: v.configFromZh = i18n.t('adminView.BleIOSApp'); break
              case 109: v.configFromZh = i18n.t('adminView.UniIOSWeChat'); break
              case 201: v.configFromZh = 'Admin'; break
              case 202: v.configFromZh = i18n.t('adminView.BleAnWeChat'); break
              case 203: v.configFromZh = i18n.t('adminView.BleIOSWeChat'); break
              case 204: v.configFromZh = 'DRM'; break
            }
            if (v.locationSample == 4294967295) v.locationSample = 0
            var extralArr2 = decimalToBinary(v.extralFuntion, 2)
            var editSensorRange
            this.sensorRangeOptions.forEach(m => {
              if (v.hallSensorRange == m.key) editSensorRange = m.label
            })
            this.setHistoryTableData.push({
              batterySystemVolt: v.batterySystemVolt,
              batteryTotalah: Math.round(v.batteryTotalah / 100),
              updateBy: v.updateBy,
              status: v.status,
              can: v.can,
              voltClass: v.voltClass,
              samplingMode: v.samplingMode,
              voltChangeRate: v.voltChangeRate,
              samplingRate: v.samplingRate ? v.samplingRate / 1000 : 0,
              gpsFunction: v.gpsFunction,
              netFunction: v.netFunction,
              apn: v.gprsApnName,
              updateTime: getDateAndHour(v.configTime),
              supportWaterlevelTd: v.supportWaterlevel == 1 ? i18n.t('BondOrUpdateDevice.Yes') : i18n.t('BondOrUpdateDevice.No'),
              ledSettingTd: v.ledSetting == 2 ? i18n.t('BondOrUpdateDevice.No') : i18n.t('BondOrUpdateDevice.Yes'),
              supportRelaycontrolTd: v.supportRelaycontrol == 1 ? i18n.t('BondOrUpdateDevice.Yes') : i18n.t('BondOrUpdateDevice.No'),
              sourceTd: v.configFromZh,
              sensorTypeTd: v.sensorType == 2 ? (editSensorRange ? 'SHUNT [' + editSensorRange + ']' : 'SHUNT') : (editSensorRange ? 'HALL [' + v.hallDirectionTd + '] [ ' + editSensorRange + ' ]' : 'HALL [' + v.hallDirectionTd + ']'),
              extralFuntionTd: extralArr2[1] == 1 ? i18n.t('BondOrUpdateDevice.On') + ' [ ' + v.locationSample + ' ' + i18n.t('BondOrUpdateDevice.SecondsTimes') + ' ]' : i18n.t('BondOrUpdateDevice.Off'),
              // 低压保护
              supportLowvolProtection: v.supportLowvolProtection == 1 ? this.$t('BondOrUpdateDevice.On') : this.$t('BondOrUpdateDevice.Off'),
              recoveryVoltage: (v.recoveryVoltage / 100).toFixed(2),
              warn1voltage: (v.warn1voltage / 100).toFixed(2),
              warn2voltage: (v.warn2voltage / 100).toFixed(2),
              warn3voltage: (v.warn3voltage / 100).toFixed(2),

              extrals: extralArr2,
              batteryId: v.batteryId,
              batteryModel: v.batteryModel,
              batteryBrand: v.batteryBrand,
              canopenBaudrate: v.canopenBaudrate,
              nodeID: v.nodeID,
              cell: v.cell,
              locationStatus: v.locationStatus,
              showAvailableTime: v.showAvailableTime,
              hourMeterStatus: v.hourMeterStatus,
              openIgnitionVol: v.openIgnitionVol,
              workHourmeterVol: v.workHourmeterVol,
              halfV: v.halfV,
              fullChargeTime: v.fullChargeTime,
              site: v.site,
              configFrom: v.configFrom,
              communication485Zh: extralArr2[3] == 1 ? i18n.t('BondOrUpdateDevice.On') : i18n.t('BondOrUpdateDevice.Off')
            })
          })
          console.log('33', this.setHistoryTableData)
        }
      })
    },
    queryList() {
      findDeviceInfo({ 'mcuId': this.$route.query.mcuId }).then(res => {
        console.log('设备信息：', res)
        if (res.resultCode == 1001) {
          if (!res.resultModel) return
          this.basicinfo.companyName = res.resultModel.companyName
        }
      })
      // this.querySoh()
    },
    init() { // 设备类型下拉框
      sysDictInfo({}).then(res => {
        res.resultModel.forEach(v => {
          this.deviceTypeOptions.push({// 编辑设备信息弹窗--设备类型多选框
            label: v.name,
            value: v.k,
            disabled: false
          })
        })
      })
    },
    updateFw(row, index) { // 弹窗--显示
      console.log(row)
      this.isShowPop = true
      if (row) { // 分页触发本事件时，无row
        this.selectDeviceObj = row
        this.selectDeviceObj.index = index
      }
      // if (row && row.deviceType == 'e') {
      //   this.selectDeviceObj.deviceModel = 'bms'
      //   getLastBMSRecor2({ mcuId: this.$route.query.mcuId }).then(res => {
      //     if (res.resultCode !== 1001) return
      //     if (res.resultModel && res.resultModel.soc < 3000) {
      //       this.$notify({
      //         title: '',
      //         message: i18n.t('adminView.SOC30'), // '电量低于30%，禁止远程更新！',
      //         type: 'warning',
      //         duration: 2000
      //       })
      //       return
      //     }
      //     if (res.resultModel && res.resultModel.current != 0) {
      //       this.$notify({
      //         title: '',
      //         message: i18n.t('adminView.InUse'), // '电池非静止状态，禁止远程更新！',
      //         type: 'warning',
      //         duration: 2000
      //       })
      //       return
      //     }
      //   })
      // }
      var param = {
        deviceModel: this.selectDeviceObj.hardwareVersion,
        // deviceVersion: 128,
        pageNum: 1,
        pageSize: 30
      }
      // if (row.deviceType == 'e' && !row.hardwareVersion && row.bms == '(BMS1)')param.deviceModel = 'bmsmain11'
      // if (row.deviceType == 'e' && !row.hardwareVersion && row.bms == '(BMS2)')param.deviceModel = 'bmsdeputy11'
      pageDeviceSystemVersionList(param).then(res => {
        // if (res.resultCode == 1001) {
        console.log('版本列表：', res)
        this.fwList = res.resultModel.list.filter(item => item.deviceVersion > this.basicinfo.fwVersion)
        // this.listQuery3.pageInfo.total = res.resultModel.total // 分页

        this.fwList.forEach(v => {
          v.updateTime = getDateAndHour(new Date(v.createTime).getTime())
        })
      })
    },
    selectFW1(row) { // 弹窗--选择FW
      this.$confirm(i18n.t('adminView.ConfirmUpdate'), '', {//
        confirmButtonText: i18n.t('button.Confirm'), // '确定'
        cancelButtonText: i18n.t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        var param = [
          {
            'mcuId': this.$route.query.mcuId, // yhub
            // 'mcuId': '003a00525847501420303142', // yhub
            'versionId': row.id,
            'fileTotalLength': row.fileSize,
            'fileTotalNum': row.fileCount,
            'hardwareVersion': row.deviceModel,
            'snId': this.selectDeviceObj.deviceId // device id
            // 'snId': '01202056789' // device id
          }
        ]
        PushUpdateIndex(param).then(res => {
          if (res.code == '200') {
            console.log('发送成功')
            this.isShowPop = false
            // <!-- 0:发送更新指令；1：开始更新；2：更新成功；3：更新失败 ;4:固件更新中-->
            this.allDeviceTableData[this.selectDeviceObj.index].status = 0
            this.updating = true
            this.selectDeviceObj.fileCount = row.fileCount
            // this.allDeviceTableData[this.selectDeviceObj.index].updateRes = Date.now()
            setTimeout(() => { // 如果一小时后还没有更新进度，则更新失败
              if (!this.allDeviceTableData[this.selectDeviceObj.index].updatedPercentage) {
                this.allDeviceTableData[this.selectDeviceObj.index].status = 3
                this.updating = false
              }
              // }, 3600000)
            }, 600000)// 假数据
            this.allDeviceTableData = [...this.allDeviceTableData]
            this.updateLogStatus(0)
          }
        })
      }).catch(() => { })
    },
    selectFW(row) { // 弹窗--选择FW
      this.$confirm(i18n.t('adminView.ConfirmUpdate'), '', {//
        confirmButtonText: i18n.t('button.Confirm'), // '确定'
        cancelButtonText: i18n.t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        console.log('更新')
        var param = {
          'mcuId': this.$route.query.mcuId, // yhub
          // 'mcuId': '003a00525847501420303142', // yhub
          'versionId': row.id,
          'fileTotalLength': row.fileSize,
          'fileTotalNum': row.fileCount,
          'hardwareVersion': row.deviceModel,
          'oldVersion': this.selectDeviceObj.fwVersion,
          'deviceId': this.selectDeviceObj.deviceId // device id
          // 'deviceId': '01202056789' // device id
        }

        deviceUpdateVersion(param).then(res => {
          if (res.resultCode == '1001') {
            console.log('发送成功')
            this.isShowPop = false
            // <!-- 0:发送更新指令；1：开始更新；2：更新成功；3：更新失败 ;4:固件更新中-->
            this.allDeviceTableData[this.selectDeviceObj.index].status = 0
            this.updating = true
            this.selectDeviceObj.fileCount = row.fileCount
            // this.allDeviceTableData[this.selectDeviceObj.index].updateRes = Date.now()
            setTimeout(() => { // 如果一小时后还没有更新进度，则更新失败
              var updatedPercentage = this.allDeviceTableData[this.selectDeviceObj.index].updatedPercentage
              if (!updatedPercentage || (updatedPercentage && updatedPercentage != 1)) {
                this.allDeviceTableData[this.selectDeviceObj.index].status = 3
                this.updating = false
                this.updateLogStatus(3)
                this.queryListAllDevice()
                this.queryListFwHistory()
              }
            }, 3600000)
            // }, 600000)// 假数据
            this.allDeviceTableData = [...this.allDeviceTableData]
            this.updateLogStatus(0)
            this.queryListFwHistory()
          }
        })
      }).catch(() => { })
    },
    updateLogStatus(val) { // 更新版本记录
      var params = {
        'deviceId': this.selectDeviceObj.deviceId,
        'mcuId': this.$route.query.mcuId,
        // 'mcuId': '05d9ff333332534e43204258', // 假数据
        'pageNum': 1,
        'pageSize': 10,
        'remark': '',
        'status': val
      }
      updateLogStatus(params).then(Response => {
        // if (Response.resultCode == 1001) this.queryListAllDevice()
      })
    },
    queryMhxqByMcuId() { // 物联网卡信息
      getMhxqByMcuId({ mcuId: this.$route.query.mcuId }).then(res => {
        if (res.resultCode == 1001) {
          if (res.resultModel) {
            var obj = res.resultModel
            if (obj.e == 1) { obj.e = i18n.t('sim.notConnected') } else { obj.e = i18n.t('sim.connected') }
            if (obj.l == 1 || obj.l == 2 || obj.l == 4 || obj.l == 8 || obj.l == 512 || obj.l == 1024 || obj.l == 2048 || obj.l == 4096 || obj.l == 8192 || obj.l == 16384) {
              obj.l = i18n.t('adminView.NotActivated')
            } else if (obj.l == 16) {
              obj.l = i18n.t('sim.activated')
            } else if (obj.l == 32 || obj.l == 64) {
              obj.l = i18n.t('sim.Deactivate')
            } else if (obj.l == 128) {
              obj.l = i18n.t('sim.cancellation')
            } else if (obj.l == 256) {
              obj.l = i18n.t('sim.Recycle')
            }
            this.simType = res.resultModel.type
            this.simData = []
            if (this.simType == 'keepgo') {
              this.simData.push(
                { name1: i18n.t('sim.PackageName'), key1: 'cb', value1: obj.rate_plan, name2: i18n.t('sim.UsedTraffic'), key2: 'bs', value2: obj.monthly_usage_mb + 'M' },
              )
              return
            }
            this.simData.push(
              { name1: i18n.t('adminView.SIMID'), key1: 'b', value1: obj.b, name2: i18n.t('sim.SimICCID'), key2: 'ab', value2: obj.ab },
              { name1: i18n.t('sim.GroupId'), key1: 'd', value1: obj.d, name2: i18n.t('sim.groupName'), key2: 'eb', value2: obj.eb },
              { name1: i18n.t('sim.PackageId'), key1: 'ba', value1: obj.ba, name2: i18n.t('sim.PackageName'), key2: 'cb', value2: obj.cb },
              { name1: i18n.t('allDeviceDetail.PackageFlow'), key1: 'br', value1: Math.round(obj.br / 1024) + 'M', name2: i18n.t('sim.UsedTraffic'), key2: 'bs', value2: Math.round(obj.bs / 1024) + 'M' },
              { name1: i18n.t('adminView.ConnectionStatus'), key1: 'e', value1: obj.e, name2: i18n.t('sim.NICstatus'), key2: 'l', value2: obj.l },
            )
          }
        }
      })
    },
    MQTT() {
      if (this.yhubmqtt) {
        // this.$route.query.mcuId = '003a00525847501420303142'
        if (!this.yhubmqtt.topic || this.yhubmqtt.topic.indexOf(this.$route.query.mcuId) == -1) return
        // console.log('this.selectDeviceObj-----', this.selectDeviceObj)

        if (this.yhubmqtt.payload === 'mUpdateIndex') {
          console.log('mUpdateIndex-----', this.yhubmqtt)
          if (this.selectDeviceObj.index !== 0 && !this.selectDeviceObj.index) return
          if (this.yhubmqtt.mUpdateIndex.dIsReadyUpdate) {
            this.allDeviceTableData[this.selectDeviceObj.index].statusS = 1 // 此时状态不需要立马改为更新中，避免百分比未拿到值
            this.updating = true
          } else { // 不可以更新
            this.allDeviceTableData[this.selectDeviceObj.index].status = 3
            this.updating = false
            this.updateLogStatus(3)
            this.queryListAllDevice()
            this.queryListFwHistory()
          }
        }
        if (this.yhubmqtt.payload === 'mUpdateFirwarePakcetByNum') {
          console.log('mUpdateFirwarePakcetByNum-----', this.yhubmqtt)
          // console.log('this.selectDeviceObj.index-----', this.selectDeviceObj.index)
          if (this.selectDeviceObj.index !== 0 && !this.selectDeviceObj.index) return

          if (this.allDeviceTableData[this.selectDeviceObj.index].statusS == 1) { // 更新中
            this.allDeviceTableData[this.selectDeviceObj.index].status = 1
            this.fwHistoryTableData[0].status = 1
            // var totle = this.yhubmqtt.mUpdateFirwarePakcetByNum.sdPacketVerison
            var totle = this.selectDeviceObj.fileCount
            var currentNum = this.yhubmqtt.mUpdateFirwarePakcetByNum.sdPacketCurrentNum + 1 || 1
            if (!currentNum) this.updateLogStatus(1)
            if (!totle) return
            if (currentNum == totle) {
              if (this.selectDeviceObj.deviceType.indexOf('a') > -1) { // yhub:更新成功
                this.allDeviceTableData[this.selectDeviceObj.index].status = 2
                this.fwHistoryTableData[0].status = 2
                this.updating = false
                this.updateLogStatus(2)
                // this.queryListFwHistory()
                return
              } else { // 非yhub ： 更新包发送成功，等待固件传输中。。。
                this.allDeviceTableData[this.selectDeviceObj.index].status = 4
                this.fwHistoryTableData[0].status = 4
                this.updating = true
                // this.updateLogStatus(2)
                // this.queryListFwHistory()
                // return
              }
            }
            // if (!currentNum) { this.allDeviceTableData[this.selectDeviceObj.index].updatedPercentage = 0; return }
            if (!(currentNum == totle && this.selectDeviceObj.deviceType.indexOf('a') == -1)) {
              this.allDeviceTableData[this.selectDeviceObj.index].updatedPercentage = Math.round((currentNum / totle).toFixed(2) * 100)
              this.fwHistoryTableData[0].updatedPercentage = Math.round((currentNum / totle).toFixed(2) * 100)
            }
          }
        }
        if (this.yhubmqtt.payload === 'mUpdateStatus' && this.selectDeviceObj.deviceType.indexOf('a') == -1) { // 非yhub
          console.log('mUpdateStatus-----', this.yhubmqtt)

          if (this.yhubmqtt.mUpdateStatus.sUpdateStatus == 1) { // 1：更新成功  2：更新失败
            this.allDeviceTableData[this.selectDeviceObj.index].status = 2
            this.fwHistoryTableData[0].status = 2
            this.updating = false
            this.updateLogStatus(2)
            return
          } else if (this.yhubmqtt.mUpdateStatus.sUpdateStatus == 2) {
            this.allDeviceTableData[this.selectDeviceObj.index].status = 3
            this.fwHistoryTableData[0].status = 3
            this.updating = false
            this.updateLogStatus(3)
            return
          }
        }
        this.allDeviceTableData = [...this.allDeviceTableData]
        this.fwHistoryTableData = [...this.fwHistoryTableData]
      }
    },
    change(e) {
      this.$forceUpdate()
    },
    querySoh(star, end) {
      var param = {
        startTime: '',
        endTime: '',
        mcuId: this.$route.query.mcuId
      }
      if (star) {
        param.startTime = star
        param.endTime = end
      }
      listSohRecord(param).then(res => {
        if (res.resultCode != 1001 || !res.resultModel) return
        this.sohData = res.resultModel
        this.sohData.forEach(v => {
          for (var attr in v) {
            if (attr == 'current_capacity' || attr == 'socVolt' || attr == 'soc_ll' || attr == 'soc_ph' || attr == 'soc_wph' || attr == 'soc_zt' || attr == 'soh_avg' || attr == 'theoretical_capacity') {
              v[attr] = Math.round(v[attr])
            }
            v.start_timeZh = getDateAndHour(v.start_time)
            v.end_timeZh = getDateAndHour(v.end_time)
          }
        })
      })
    },
    computedSoh() { // 手动计算soh
      var param = {
        'startDate': new Date(this.sohSearchObj.sohStartAndEndtime[0]).getTime(),
        'endDate': new Date(this.sohSearchObj.sohStartAndEndtime[1]).getTime() + 24 * 60 * 60 * 1000 - 1,
        'mcuId': this.$route.query.mcuId,
        'ignoreCharge': this.sohSearchObj.ignoreCharge,
        'updateData': this.sohSearchObj.updateData
      }
      this.loadingSoh = true
      if (param.endDate - param.startDate > 24 * 60 * 60 * 1000 * 3) {
        this.$message({
          type: 'warning',
          message: i18n.t('adminView.Duration3')// '起止时间不能太大，必须控制在3天内'// i18n.t('allDeviceDetail.DeviceNameCannotEmpty')
        })
        return
      }
      countSoh(param).then(res => {
        this.loadingSoh = false
        if (res.resultCode == 1001) {
          if (!res.resultModel) {
            this.$message({
              type: 'success',
              message: i18n.t('allDeviceDetail.noEligibleData')// '计算成功,但本次计算无符合条件的数据！'
            })
          }
          if (res.resultModel) {
            this.$message({
              type: 'success',
              message: i18n.t('allDeviceDetail.calcSuccess')// '计算成功！'
            })
            var star = new Date(this.sohSearchObj.sohStartAndEndtime[0]).getTime()
            var end = new Date(this.sohSearchObj.sohStartAndEndtime[1]).getTime() + 24 * 60 * 60 * 1000 - 1
            this.querySoh(star, end)
          }
        }
      })
    },
    changeSOhTime(val) { // soh改变时间
      console.log('11', val)
      if (val) {
        this.sohSearchObj.sohStartAndEndtime = val
        var star = new Date(val[0]).getTime()
        var end = new Date(val[1]).getTime() + 24 * 60 * 60 * 1000 - 1
        this.querySoh(star, end)
      }
    },
    sohChangeSearch() {
      if (!this.sohSearchObj.sohStartAndEndtime || this.sohSearchObj.sohStartAndEndtime.length == 0) return
      // this.computedSoh()
    },
    // decimalToBinary (num, digits) { // 十进制转二进制  digits:代表传过来的是几位数，避免用<10判断出错，如：01 本应该转成8位，却转成了4位
    //   var myNum = num
    //   var b = []
    //   while (1) {
    //     var remainder = num % 2
    //     b.unshift(remainder)
    //     num = parseInt(num / 2)
    //     if (num == 0) break
    //   }
    //   var len
    //   if (!digits || digits == 1) {
    //     len = 4 - b.length
    //     for (var i = 0; i < len; i++) {
    //       b.unshift(0)
    //     }
    //     // } else if (myNum >= 10 && myNum < 100) {
    //   } else if (digits == 2) {
    //     len = 8 - b.length
    //     for (var j = 0; j < len; j++) {
    //       b.unshift(0)
    //     }
    //   }
    //   return b.reverse()
    // },
    // 分页----start
    handleSizeChange1(val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery1.pageInfo.pageSize = val
      this.queryListAllDevice()
    },
    handleCurrentChange1(val, e) { // 选中某一页
      this.listQuery1.pageInfo.pageNum = val
      this.queryListAllDevice()
    },
    // 分页----end
    // 分页----start
    handleSizeChange2(val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery2.pageInfo.pageSize = val
      this.queryListFwHistory()
    },
    handleCurrentChange2(val, e) { // 选中某一页
      this.listQuery2.pageInfo.pageNum = val
      this.queryListFwHistory()
    },
    // 分页----end
    // 分页----start
    handleSizeChange3(val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery3.pageInfo.pageSize = val
      this.updateFw()
    },
    handleCurrentChange3(val, e) { // 选中某一页
      this.listQuery3.pageInfo.pageNum = val
      this.updateFw()
    },
    // 分页----end
    // 分页----start
    handleSizeChange4(val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery4.pageInfo.pageSize = val
      this.queryListSetHistory()
    },
    handleCurrentChange4(val, e) { // 选中某一页
      this.listQuery4.pageInfo.pageNum = val
      this.queryListSetHistory()
    },
    handleSizeChange5(val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery5.pageInfo.pageSize = val
      this.queryListCalibrationHistory()
    },
    handleCurrentChange5(val, e) { // 选中某一页
      this.listQuery5.pageInfo.pageNum = val
      this.queryListCalibrationHistory()
    }
    // 分页----end
  }
}
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}
#yhubDetail {
  // height:100%;
  .tableWarp {
    background: #fff;
    margin-top: 20px;
  }
  .statusDiv {
    width: 100%;
    height: 20px;
    background: #f3f3f3;
    margin-top: 2px;
  }
  .greenStatus {
    width: 33%;
    background: #43d043;
    height: 20px;
  }
  .yellowStatus {
    width: 66%;
    background: #f7f73f;
    height: 20px;
  }
  .redStatus {
    width: 100%;
    background: #fb2b2b;
    height: 20px;
  }
  .demo-table-expand .el-form-item {
    margin-bottom: 0;
  }
}
</style>
<style lang="scss">
#yhubDetail {
  .deviceNameTable {
    width: 200px;
  }
}
.simTable {
  th:nth-of-type(odd),
  td:nth-of-type(odd) {
    background: #f0f2f591;
  }
}
</style>
